<div *ngIf="showRules==true && hasErrors" style="font-size: 0.85em;">
    <ul class="pt-1 list-group">
        <li class="list-group-item border-0 p-0" *ngFor="let rule of rules; index as i;">
            <i class="text-success fa-solid fa-check pe-2" *ngIf="rule.error==false"></i><i class="text-danger fa-solid fa-xmark pe-2" *ngIf="rule.error==true"></i>   <span>{{rule.text | capitalize}}</span>
        </li>
    </ul>
</div>